import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/claims/history']['get']['responses']['200']['content']['application/json']

export type LoyaltyClaimHistoryEntry = Response['result']['claims'][number]

/** The authenticated customer's claims across all claim campaigns. */
async function requestLoyaltyClaimHistory(): Promise<Array<LoyaltyClaimHistoryEntry>> {
  const response = await requestUtils.get<Response>(
    '/api/lux-loyalty/claims/history',
    { credentials: 'include', excludeBrand: true },
  )
  return response.result.claims
}

export default requestLoyaltyClaimHistory
